
export default {
  props: {
    lat: {
      type: String,
      default: '0'
    },
    lng: {
      type: String,
      default: '0'
    }
  },
  computed: {
    embedUrl() {
      return `https://www.google.com/maps/embed/v1/view?key=${process.env.GOOGLE_MAP_API_KEY}&center=${this.lat},${this.lng}&zoom=18`
    }
  }
}
